import { put, call, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { flashMessage } from "redux-flash";
import { logoutRequest } from "../login/actions";

import {
  GET_INVOICES_REQUEST,
  getInvoicesSuccess,
  getInvoicesError,
} from "./actions";
import { Env } from "../../env";

function* getInvoicesRequest(action) {
  const { accessToken, userId, starting_after, ending_before, limit } = action;
  let response;

  try {
    let config = {
      params: { starting_after, ending_before, limit },
      headers: { Authorization: accessToken },
    };
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Accounts/${userId}/getInvoices`,
      config
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(
        getInvoicesError("Une erreur s'est produite, veuillez réessayer.")
      );
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }
  yield put(getInvoicesSuccess(response.data));
}

export default function* watchGetInvoicesRequest() {
  yield takeLatest(GET_INVOICES_REQUEST, getInvoicesRequest);
}



// WEBPACK FOOTER //
// ./src/pages/userinvoices/saga.js